import { STANDALONE_REDIRECTS } from './constants';

export function filterProductsByTitle(title, list = []) {
  return title === ''
    ? list
    : list.filter((p) => p.title.toLowerCase().includes(title.toLowerCase()));
}

export function getStandardAloneUrl(product) {
  return STANDALONE_REDIRECTS.find(
    (r) => r.name.toLowerCase() === product.title.toLowerCase()
  )?.url || '';
}

export function applyRedirectUrls(products, shouldRedirect) {
  return shouldRedirect ? products.map((product) => ({
    ...product,
    primaryCta: {
      ...product.primaryCta,
      url: getStandardAloneUrl(product) || product.primaryCta.url
    }
  })) : products;
}
